export default "__VITE_ASSET__6273eaf1__"